/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{list-style:none;margin:0 -15px 20px;padding:13px 15px 1px;background-color:#c0f0ff;border:1px solid #0092a8}.message[_ngcontent-%COMP%]{margin-bottom:10px}"];
export { styles as styles };
